import {ConsentEmbed} from "../embeds/embed.element";

if (!customElements.get('sso-embed')) {
    customElements.define('sso-embed', ConsentEmbed);
}
